<div class="toggle-mode" (click)="toggleDarkMode()">
  <img [src]="(isDarkMode$ | async) ? 'assets/images/header/dark-mode.svg' : 'assets/images/header/light-mode.svg'" alt="change theme" />
</div>
